import { render, staticRenderFns } from "./organisation-list.vue?vue&type=template&id=7c03aa0c"
import script from "./organisation-list.vue?vue&type=script&lang=js"
export * from "./organisation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports